import React from 'react';

import {Trans, useTranslation} from 'react-i18next';
import {
    FontVariant,
    TextHeading,
    Text,
    Form,
    Input,
    Bar,
    Button,
} from '@pexip/components';
import {TestId} from '../../../test/testIds';

export const Register: React.FC<{
    onSubmit: (deviceAlias: string) => void;
    isLoading?: boolean;
    error?: string;
}> = ({onSubmit, isLoading = false, error}) => {
    const {t} = useTranslation();
    const [deviceAlias, setDeviceAlias] = React.useState('');

    return (
        <>
            <TextHeading
                htmlTag="h2"
                fontVariant={FontVariant.H2}
                className="mb-2"
            >
                <Trans t={t} i18nKey="register.title">
                    Sign in
                </Trans>
            </TextHeading>
            <Text>
                <Trans t={t} i18nKey="register.description">
                    Please enter your video address to register your app and
                    receive calls. You can find your video address in the email
                    sent by your administrator.
                </Trans>
            </Text>
            <Form
                onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    if (deviceAlias.trim()) {
                        onSubmit(deviceAlias.trim());
                    }
                }}
            >
                <Input
                    hasError={!!error}
                    errorText={error}
                    autoComplete="off"
                    className="mt-5 mb-5"
                    label={t(
                        'register.your-video-address',
                        'Your video address',
                    )}
                    name="video-address"
                    placeholder={t(
                        'register.video-address-placeholder',
                        `name.lastname@example.com`,
                    )}
                    type="text"
                    value={deviceAlias}
                    onChange={e => setDeviceAlias(e.target.value)}
                    data-testid={TestId.InputRegisterDeviceAlias}
                />

                <Bar>
                    <Button
                        modifier="fullWidth"
                        type="submit"
                        size="large"
                        isDisabled={!deviceAlias.trim() || isLoading}
                        isLoading={isLoading}
                        data-testid={TestId.ButtonRegisterNext}
                    >
                        <Trans t={t} i18nKey="common.next">
                            Next
                        </Trans>
                    </Button>
                </Bar>
            </Form>
        </>
    );
};
